import React, { useState } from 'react';
import { Modal, Radio, Button, message } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { productImagesSort } from '../../services/productService';
import './image-modal.scss';

function ImageModal(props: any) {
    const { visible, images, id, onClose, refreshProductInfo } = props;
    const [imgs, setImgs] = useState(images);
    const [radio, setRadio] = useState(images?.[0]?.id || null);

    function handleIconClick(e, operation, id) {
        e.stopPropagation();
        const newImgs = [...imgs];
        const index = newImgs.findIndex((item) => item?.id === id);
        const changeIndex = index + operation;
        if(changeIndex < 0 || changeIndex >= newImgs.length) return;
        const temp = {...newImgs[index]};
        newImgs[index] = {...newImgs[changeIndex]};
        newImgs[changeIndex] = {...temp};
        setImgs(newImgs);
    }

    function handleRadioChange(e) {
        setRadio(e.target.value);
    }

    function handleSave() {
        const imageIds = imgs.map((item) => item.id);
        productImagesSort(id, {imageIds})
            .then(res => {
                message.success('修改保存成功');
                refreshProductInfo && refreshProductInfo();
                onClose && onClose();
            }).catch(err => {
                message.error('保存失败');
            })
    }

    function setMainImage() {
        if(!radio) return;
        const newImgs = [...imgs];
        const index = newImgs.findIndex((item) => item?.id === radio);;
        const temp = {...newImgs[index]};
        newImgs.splice(index, 1);
        newImgs.unshift(temp);
        setImgs(newImgs);
    }

    return (
        <Modal
            visible={visible}
            title='商品图片'
            width='70%'
            onCancel={onClose}
            footer={
                <div>
                    <Button onClick={setMainImage}>设为主图</Button>
                    <Button type="primary" onClick={handleSave}>保存</Button>
                </div>
            }
        >
            <div className='image-modal-content'>
                <Radio.Group value={radio} onChange={handleRadioChange}>
                    {imgs?.map((image) => {
                        return (
                            <div key={image?.id}>
                                <div className='image-wrap'>
                                    <img className='product-main-img' src={image?.full?.url} />
                                    <div className='mask'>
                                        <LeftOutlined onClick={(e) => handleIconClick(e, -1, image?.id)} style={{color: '#ffffff'}} />
                                        <RightOutlined onClick={(e) => handleIconClick(e, 1, image?.id)} style={{color: '#ffffff'}} />
                                    </div>
                                </div>
                                <Radio value={image?.id}></Radio>
                            </div>
                        )
                    })}
                </Radio.Group>
            </div>
        </Modal>
    )
}

export default ImageModal;